"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  ruler: {
    position: 'absolute',
    background: 'transparent !important'
  },
  rulerTop: {
    top: -20,
    left: 0,
    width: '100%',
    height: 20
  },
  rulerRight: {
    top: 0,
    right: -20,
    width: 20,
    height: '100%'
  },
  rulerBottom: {
    bottom: 3,
    left: 0,
    width: '100%',
    height: 20
  },
  rulerLeft: {
    top: 0,
    left: 3,
    width: 20,
    height: '100%'
  }
};